// /blackUsers 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 6개를 이 배열 하나로 대체한다. field 키 / operator / 옵션값은 기존과 100% 동일.

import type { SearchFieldConfig } from "components/list";

const SIDO_OPTIONS = [
  { value: "", label: "전체" },
  { value: "서울특별시", label: "서울특별시" },
  { value: "부산광역시", label: "부산광역시" },
  { value: "대구광역시", label: "대구광역시" },
  { value: "인천광역시", label: "인천광역시" },
  { value: "광주광역시", label: "광주광역시" },
  { value: "대전광역시", label: "대전광역시" },
  { value: "울산광역시", label: "울산광역시" },
  { value: "세종특별자치시", label: "세종특별자치시" },
  { value: "경기도", label: "경기도" },
  { value: "충청북도", label: "충청북도" },
  { value: "충청남도", label: "충청남도" },
  { value: "전북특별자치도", label: "전북특별자치도" },
  { value: "전라남도", label: "전라남도" },
  { value: "경상북도", label: "경상북도" },
  { value: "경상남도", label: "경상남도" },
  { value: "제주특별자치도", label: "제주특별자치도" },
  { value: "강원특별자치도", label: "강원특별자치도" },
];

export const blackUsersSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID에서 검색", type: "text", operator: "contains", width: 140 },
  { name: "loginId", label: "로그인ID에서 검색", type: "text", operator: "contains", width: 200 },
  { name: "nickName", label: "닉네임에서 검색", type: "text", operator: "contains", width: 200 },
  {
    name: "auth",
    label: "권한",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "TEACHER", label: "교사" },
      { value: "DIRECTOR", label: "시설관리자" },
    ],
  },
  { name: "address", label: "주소에서 검색", type: "text", operator: "contains", width: 220 },
  { name: "sido", label: "시도 선택", type: "select", operator: "eq", width: 160, options: SIDO_OPTIONS },
];
